import React, { FC } from "react"

import { generateConditionalClassName } from "@utils"
import Icon, { ICON_TYPES } from "@components/Icon/Icon"

import "./SubmissionMessage.scss"

type SubmissionMessageProps = {
  successMessage?: string,
  errorMessage?: string,
  isSubmitting?: boolean,
}

const SubmissionMessage: FC<SubmissionMessageProps> = ({
  successMessage,
  errorMessage,
  isSubmitting,
}) => {
  const hasError = !isSubmitting && !!errorMessage
  return (
    <div
      className={generateConditionalClassName({
        "HubspotForm--SubmissionMessage": true,
        "has-error": hasError,
      })}
    >
      {!isSubmitting && successMessage && (
        <span>
          <Icon
            color="var(--color--success-icon)"
            size="22px"
            type={ICON_TYPES["checkmark"]}
          />
          <span dangerouslySetInnerHTML={{ __html: successMessage }} />
        </span>
      )}
      {!isSubmitting && errorMessage && (
        <span>
          <Icon
            color="var(--color--error-icon)"
            size="22px"
            type={ICON_TYPES["alert-error"]}
          />
          <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
        </span>
      )}
      {isSubmitting && (
        <span>
          <Icon
            color="var(--color--success-icon)"
            size="22px"
            type={ICON_TYPES["loading"]}
          />
          Sending...
        </span>
      )}
    </div>
  )
}

export default SubmissionMessage
